import * as z from "zod/v4";

import { followUpAnswerKeys, situationAnswerKeys } from "../associate-leads";

export const situationAnswerSchema = z.enum(situationAnswerKeys, {
	error: "Please choose an answer"
});
export const followUpAnswerSchema = z.enum(followUpAnswerKeys, {
	error: "Please choose an answer"
});

const otherTextSchema = z.string().trim().max(1000, "Please keep this under 1,000 characters");

export const submitAssociateFormSchema = z.object({
	situation: situationAnswerSchema,
	situationOther: otherTextSchema,
	timeline: followUpAnswerSchema,
	timelineOther: otherTextSchema,
	workLevel: followUpAnswerSchema,
	workLevelOther: otherTextSchema,
	address: z.string().trim().min(1, "Please enter the property address"),
	addressStreetNumber: z.string().trim(),
	addressRoute: z.string().trim(),
	name: z.string().trim().min(3, "Please enter your name"),
	phone: z.string().regex(/^\(\d{3}\) \d{3}-\d{4}$/, "Phone must be in format (XXX) XXX-XXXX"),
	email: z.email("Valid email is required"),
	turnstileToken: z.string(),
	associateSlug: z.string().min(1),
	pageUrl: z.url(),
	routeId: z.string(),
	utmSource: z.string(),
	utmMedium: z.string(),
	utmCampaign: z.string(),
	utmContent: z.string(),
	utmTerm: z.string()
});

export type SubmitAssociateFormSchema = z.infer<typeof submitAssociateFormSchema>;

export const submitAssociateFormClientSchema = submitAssociateFormSchema.pick({
	situation: true,
	situationOther: true,
	timeline: true,
	timelineOther: true,
	workLevel: true,
	workLevelOther: true,
	address: true,
	addressStreetNumber: true,
	addressRoute: true,
	name: true,
	phone: true,
	email: true,
	turnstileToken: true
});
